/**
 * Settlements Tour Configuration
 */

import { filterExistingSteps } from './tourUtils.js';

export const getSettlementsTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="settlements-summary"]',
      content: t('tour.settlements.summary', {
        ns: 'common',
        defaultValue: 'View your settlement summary: total settlements, mobile money payouts, and bank transfers. Track your settlement activity at a glance.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="settlements-history"]',
      content: t('tour.settlements.history', {
        ns: 'common',
        defaultValue: 'Browse your complete settlement history. See all past transactions with details like reference, date, method, amount, charges, and status.',
      }),
      position: 'top',
    },
    {
      selector: '[data-tour="settlements-request"]',
      content: t('tour.settlements.request', {
        ns: 'common',
        defaultValue: 'Raise a new settlement request here. Choose between full or partial payout, enter the amount, and submit your request for review.',
      }),
      position: 'top',
    },
  ]);
